import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface AttributeSelectionRuleInterface {
    formVisible: boolean,
    formVariant: "new" | "edit",
    editId?: string,
    editTitle?: string,
    editAlias?: string,
    editActive?: boolean,
    editDepth?: string,
    deleteModalVisible: boolean,
    deleteId?: string,
}

function getInitialState(): AttributeSelectionRuleInterface {
    return {
        formVisible: false,
        formVariant: "new",
        deleteModalVisible: false,
    }
}

export const AttributeSelectionRulesSlice = createSlice({
    name: "AttributeSelectionRulesSlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => {
            return getInitialState()
        },
        updateFields: (state, action: PayloadAction<Partial<AttributeSelectionRuleInterface>>) => {
            Object.assign(state, action.payload)
        }
    },
});

export const {
    reset,
    updateFields
} = AttributeSelectionRulesSlice.actions;

export const AttributeSelectionRulesSelectors = {
    formVisible: (state: RootState) => state.attributeSelectionRules.formVisible,
    formVariant: (state: RootState) => state.attributeSelectionRules.formVariant,
    editId: (state: RootState) => state.attributeSelectionRules.editId,
    editTitle: (state: RootState) => state.attributeSelectionRules.editTitle,
    editAlias: (state: RootState) => state.attributeSelectionRules.editAlias,
    editActive: (state: RootState) => state.attributeSelectionRules.editActive,
    editDepth: (state: RootState) => state.attributeSelectionRules.editDepth,
    deleteModalVisible: (state: RootState) => state.attributeSelectionRules.deleteModalVisible,
    deleteId: (state: RootState) => state.attributeSelectionRules.deleteId,
}

export const AttributeSelectionRulesReducer = AttributeSelectionRulesSlice.reducer;
